import {MNullable} from '../Toolkit/Utils';
import * as Yup from 'yup';
import {NoticeHeader, NoticeDetail} from './NoticeTypes';

export class Registration {
    public static readonly DigLocationMaxLength = 100;
    public static readonly CommentMaxLength = 8000;

    public id: number = 0;
    public noticeId: number = 0;
    public digNumber: number = 0;
    public digLocation?: string = undefined;
    public reinstatementDate: MNullable<Date> = null;
    public digLength?: number = undefined;
    public digWidth?: number = undefined;
    public digDepth?: number = undefined;
    public eastings?: number = undefined;
    public northings?: number = undefined;
    public eastings2?: number = undefined;
    public northings2?: number = undefined;
    public tempPerm?: boolean = undefined;
    public surfaceType?: number = undefined;
    public regStatus?: number = undefined;
    public comments?: string = undefined;
    public createdOn?: MNullable<Date> = null;
    public createdBy?: string = undefined;
}

export class RegistrationListItem {
    public registration: MNullable<Registration> = null;
    public noticeHeader: MNullable<NoticeHeader> = null;
    public noticeDetail: MNullable<NoticeDetail> = null;
}

export class CreateRegistrationValidator {
    public static readonly surfaceType = Yup.number().nullable().min(-1, "Surface Type is required").required();
    public static readonly reinstatementDate = Yup.date().nullable().required();
    public static readonly digLocation = Yup.string().nullable().max(Registration.DigLocationMaxLength).required();
    public static readonly digLength = Yup.number().nullable().min(0.0, "Dig Length is Required").required();
    public static readonly digWidth = Yup.number().nullable().min(0.0, "Dig Width is Required").required();
    public static readonly digDepth = Yup.number().nullable().min(0.0, "Dig Depth is Required").required();
    public static readonly tempPerm = Yup.number().nullable().min(0, "Temp/Perm is Required").required();
    public static readonly eastings = Yup.number().nullable().min(0, "Easting is Required").required();
    public static readonly northings = Yup.number().nullable().min(0, "Northing is Required").required();
}

export class UpdateRegistrationValidator {
    public static readonly surfaceType = Yup.number().min(-1, "Surface Type is required").required();
    public static readonly reinstatementDate = Yup.date().nullable().required();
    public static readonly digLocation = Yup.string().max(Registration.DigLocationMaxLength).required();
    public static readonly digLength = Yup.number().nullable().min(0.0, "Dig Length is Required").required();
    public static readonly digWidth = Yup.number().nullable().min(0.0, "Dig Width is Required").required();
    public static readonly digDepth = Yup.number().nullable().min(0.0, "Dig Depth is Required").required();
    public static readonly eastings = Yup.number().nullable().min(0, "Easting is Required").required();
    public static readonly northings = Yup.number().nullable().min(0, "Northing is Required").required();
    public static readonly comments = Yup.number().nullable().max(Registration.CommentMaxLength).optional();
}

export class RegistrationReply {
    public registration: MNullable<Registration> = null;
}

export class RegistrationMultiReply {
    public registrations: Registration[] = [];
}

export class RegistrationListReply {
    public registrations: RegistrationListItem[] = [];
}